// extracted by mini-css-extract-plugin
export default {"search":"SearchBar_search__ubI+q","inputGroup":"SearchBar_inputGroup__bojbp","icon":"SearchBar_icon__M3vnV","input":"SearchBar_input__u1wBb"};